import { rowScalar } from '../../encounter-map/ft3d/perception';
import { readInventoryRows } from '../compile/inventory-raw-readers';
import { statusRows } from '../statuses/expiry';
type Row=Record<string,unknown>;
// Older savers must refuse a split rather than silently moving its whole source row during bundle rollout.
export const HAND_DROP_SPLIT_SCHEMA = 'janus.inventory.floor_move.v3';
export interface HandDropSnapshot {
  equipped_before: string;
  wares_before: number;
  split?: { kind: 'inventory-split'; inventory_id: string; item_qty: number; source_qty_after: number };
}
/** Decide the two row identities and quantities once, before physics or dice. */
export function handDropSnapshot(row:Row,quantity:number):HandDropSnapshot {
  const total = Number(rowScalar(row,'item_qty')??1);
  if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > total) throw new Error('hand-drop:quantity-changed');
  const snapshot: HandDropSnapshot = {equipped_before:String(rowScalar(row,'equipped')??''),wares_before:Number(rowScalar(row,'inventory_wares')??0)};
  if (quantity < total) {
    // A stateful stack needs an explicit per-copy plan; never strand its contents or statuses.
    if (readInventoryRows(row, 'inventory_in_container').length || statusRows(row, 'target').length
      || Object.keys(row.charges ?? {}).length) throw new Error('hand-drop:partial-state-unported');
    snapshot.split = { kind: 'inventory-split', inventory_id: crypto.randomUUID().toUpperCase(), item_qty: quantity, source_qty_after: total - quantity };
  }
  return snapshot;
}

/** Physics sees the destination holder; the original stored row remains the CAS source. */
export function looseFloorRow(row: Row, encounterId: string): Row {
  return { ...row, inventory: { ...(row.inventory as Row), possess_id: encounterId, equipped: null, inventory_wares: 0 } };
}
